// extracted by mini-css-extract-plugin
export default {"arrow":"Arrow_arrow__NIle5","arrowUp":"Arrow_arrowUp__uFz6E","arrowLeft":"Arrow_arrowLeft__nDbfG","arrowRight":"Arrow_arrowRight__UzVXN"};